import CommonApi from '../commonApi';
import type { Channel } from '../types';

const basedUrl = 'channel';
const channel = new CommonApi<Channel>(basedUrl, 'канал учета БОС');

export default channel;
